import { gql } from "@apollo/client";

const USERS_THIRD_PARTIES = gql`
  query userThirdPartyLicenses($userId: Int) {
    userThirdPartyLicenses(userId: $userId)
  }
`;

export default USERS_THIRD_PARTIES;
